<div style="padding-top: 10px" id="messageToggle" (click)="show? hideMessages() : showMessages()">
  Messages ({{messageCount}}) <i id="messageToggleIcon" [ngClass]="show ? 'fa fa-chevron-circle-down' : 'fa fa-chevron-circle-right'"></i>
</div>

<div id="messageFloat" *ngIf="show" (appClickOutside)="hideMessages()">
  <div *ngFor="let msg of messages; let i = index" [attr.data-index]="i" class="alert alert-dismissible" [ngClass]="msg.type">
    <button name="messageClose" type="button" class="close" (click)="clearMessage(i)">
      &times;
    </button>
    {{msg.text}}
    <span class="pull-right" *ngIf="msg.count > 1">({{msg.count}})</span>
  </div>
</div>
